import React, { useState } from 'react';
import { List, ListItem, ListItemText, Collapse, Typography } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';

const LearnMoreSidebar = () => {
  const [open, setOpen] = useState({});
  const location = useLocation();

  const handleClick = (item) => {
    setOpen((prevOpen) => ({ ...prevOpen, [item]: !prevOpen[item] }));
  };

  const menuItems = [
    {
      title: 'Onboarding',
      path: '/learn-more/onboarding',
    },
    {
      title: 'Dashboard',
      path: '/learn-more/dashboard',
      subItems: [
        { title: 'Overview', path: '/learn-more/dashboard' },
        { title: 'Calendar', path: '/learn-more/dashboard/calendar' },
        { title: 'Call Logs', path: '/learn-more/dashboard/call-logs' },
        { title: 'Call Analytics', path: '/learn-more/dashboard/call-analytics' },
        { title: 'FAQ', path: '/learn-more/dashboard/faq' },
      ],
    },
    {
      title: 'AI Talker',
      path: '/learn-more/aitalker',
      subItems: [
        { title: 'Overview', path: '/learn-more/aitalker' },
        { title: 'Use Cases', path: '/learn-more/aitalker/use-cases' },
        { title: 'Configuration', path: '/learn-more/aitalker/configuration' },
        { title: 'Playground', path: '/learn-more/aitalker/playground' },
        { title: 'Integration', path: '/learn-more/aitalker/integration' },
      ],
    },
    {
      title: 'Settings',
      path: '/learn-more/settings',
      subItems: [
        { title: 'Profile Settings', path: '/learn-more/settings/profile' },
        { title: 'User Management', path: '/learn-more/settings/user-management' },
        { title: 'Billing and Payment', path: '/learn-more/settings/billing' },
        { title: 'Security Settings', path: '/learn-more/settings/security' },
      ],
    },
  ];

  return (
    <List component="nav" aria-labelledby="nested-list-subheader" sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
      {menuItems.map((item) => (
        <React.Fragment key={item.title}>
          <ListItem
            button
            component={Link}
            to={item.path}
            onClick={() => item.subItems && handleClick(item.title)}
            selected={location.pathname === item.path}
          >
            <ListItemText primary={<Typography variant="h6">{item.title}</Typography>} />
            {item.subItems && (open[item.title] ? <ExpandLess /> : <ExpandMore />)}
          </ListItem>
          {item.subItems && (
            <Collapse in={open[item.title]} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                {item.subItems.map((subItem) => (
                  <ListItem
                    button
                    sx={{ pl: 4 }}
                    key={subItem.title}
                    component={Link}
                    to={subItem.path}
                    selected={location.pathname === subItem.path}
                  >
                    <ListItemText primary={subItem.title} />
                  </ListItem>
                ))}
              </List>
            </Collapse>
          )}
        </React.Fragment>
      ))}
    </List>
  );
};

export default LearnMoreSidebar;
